
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function TestimonialsCTASection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    employees: '',
    industry: '',
    message: ''
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  return (
    <section className="section-wrap bg-gradient-to-br from-[#2D7F3E] to-[#245A2E] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="section-heading text-white">
              Ready to See Results Like These?
            </h2>
            <p className="text-xl text-green-100 mb-8 leading-relaxed">
              Join the growing list of successful businesses that have transformed their workforce with Sylman Academy's expert training solutions.
            </p>

            <div className="space-y-6">
              <div className="flex items-start">
                <div className="bg-white/20 rounded-full p-2 mr-4 mt-1">
                  <i className="ri-check-line text-white text-lg"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">Free Consultation</h3>
                  <p className="text-green-100">Discuss your training needs with our experts</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="bg-white/20 rounded-full p-2 mr-4 mt-1">
                  <i className="ri-file-text-line text-white text-lg"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">Customised Proposal</h3>
                  <p className="text-green-100">Receive a tailored training solution for your business</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="bg-white/20 rounded-full p-2 mr-4 mt-1">
                  <i className="ri-money-dollar-circle-line text-white text-lg"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">SETA Funding Support</h3>
                  <p className="text-green-100">Maximise your training budget with grant assistance</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="bg-white/20 rounded-full p-2 mr-4 mt-1">
                  <i className="ri-trophy-line text-white text-lg"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">Proven Results</h3>
                  <p className="text-green-100">Join 150+ companies achieving measurable success</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Form */}
          <div className="bg-white rounded-2xl p-8 text-gray-900">
            <h3 className="text-2xl font-bold text-[#1A1A1A] mb-6 text-center">
              Request Your Consultation
            </h3>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#2D7F3E] focus:border-transparent text-sm"
                    placeholder="Your full name"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#2D7F3E] focus:border-transparent text-sm"
                    placeholder="your.email@company.com"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Company Name *
                  </label>
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#2D7F3E] focus:border-transparent text-sm"
                    placeholder="Your company name"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#2D7F3E] focus:border-transparent text-sm"
                    placeholder="+27 XX XXX XXXX"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Number of Employees
                  </label>
                  <select
                    name="employees"
                    value={formData.employees}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#2D7F3E] focus:border-transparent text-sm pr-8"
                  >
                    <option value="">Select range</option>
                    <option value="1-10">1-10 employees</option>
                    <option value="11-50">11-50 employees</option>
                    <option value="51-200">51-200 employees</option>
                    <option value="201-500">201-500 employees</option>
                    <option value="500+">500+ employees</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Industry
                  </label>
                  <select
                    name="industry"
                    value={formData.industry}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#2D7F3E] focus:border-transparent text-sm pr-8"
                  >
                    <option value="">Select industry</option>
                    <option value="retail">Retail</option>
                    <option value="manufacturing">Manufacturing</option>
                    <option value="logistics">Logistics</option>
                    <option value="financial">Financial Services</option>
                    <option value="hospitality">Hospitality</option>
                    <option value="agriculture">Agriculture</option>
                    <option value="technology">Technology</option>
                    <option value="healthcare">Healthcare</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Training Requirements
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#2D7F3E] focus:border-transparent text-sm resize-none"
                  placeholder="Tell us about your training needs, challenges, or specific programmes you're interested in..."
                />
                <div className="text-xs text-gray-500 mt-1">
                  {formData.message.length}/500 characters
                </div>
              </div>

              <Button 
                type="submit" 
                variant="primary" 
                size="lg" 
                className="w-full bg-[#2D7F3E] hover:bg-[#245A2E]"
              >
                Request Consultation
                <i className="ri-arrow-right-line ml-2"></i>
              </Button>
            </form>

            <div className="mt-6 text-center text-sm text-gray-600">
              <p>
                <i className="ri-shield-check-line text-[#2D7F3E] mr-1"></i>
                Your information is secure and will only be used to contact you about your training needs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
